export default function TimeLeft({
  time=0
}: {time:number}) {
  var timeInt = Math.floor(time);

  return (
    <span className="text-xl">
      Time Left: {Math.floor(timeInt / 60)}:{Math.floor(time % 60)
        .toString()
        .padStart(2, "0")}
    </span>
  )
}
